import React, { Component } from "react";
import Chart from "react-apexcharts";

class PieChart extends Component {
  constructor(props) {
    super(props);
    this.state = {
      chartData: [],
      chartOptions: {},
    };
  }

  componentDidMount() {
    const { pieChartData, pieChartOptions } = this.props;

    this.setState({
      chartData: pieChartData,
      chartOptions: pieChartOptions,
    });
  }

  componentDidUpdate(prevProps) {
    if (
      JSON.stringify(prevProps.pieChartData) !== JSON.stringify(this.props.pieChartData) ||
      JSON.stringify(prevProps.pieChartOptions) !== JSON.stringify(this.props.pieChartOptions)
    ) {
      this.setState({
        chartData: this.props.pieChartData,
        chartOptions: this.props.pieChartOptions,
      });
    }
  }

  render() {
    if (!this.state || !this.state.chartData || !this.state.chartData.length) {
      return null;
    }

    return (
      <Chart
        options={this.state.chartOptions}
        series={this.state.chartData}
        type="pie"
        width="100%"
        height="100%"
      />
    );
  }
}

export default PieChart;
